<template>
  <router-link v-if="allowed" class="m-tab-link" :to="to">
    <slot />
    <slot name="counter" />
  </router-link>
  <NeedSub v-else class="lock" @close="$emit('close')">
    <span class="m-tab-link m-tab-link--locked">
      <slot />
      <LockIcon class="m-tab-lock" />
      <slot name="counter" />
    </span>
  </NeedSub>
</template>

<script setup>
import { computed, defineEmits } from "vue";
import { useStore } from "vuex";
import NeedSub from "./modal/NeedSub.vue";
import LockIcon from "./common/icons/Lock.vue";

// Пункт мобильного меню с гейтингом по праву: нет доступа → замок + модалка.
// Стили под мобильное меню (крупный шрифт), поэтому отдельный компонент.
defineEmits(["close"]);

const props = defineProps({
  permission: {
    type: String,
    required: true,
  },
  to: {
    type: String,
    required: true,
  },
});

const store = useStore();
const allowed = computed(() => store.getters.hasPermission(props.permission));
</script>

<style lang="scss" scoped>
.m-tab-link {
  display: flex;
  gap: 6px;
  align-items: center;
  color: var(--back-color);
  font-size: 36px;
  font-weight: 500;
  line-height: 46.8px;

  &.router-link-active {
    color: var(--brand-color);
  }
}
.m-tab-link--locked {
  cursor: pointer;
}
.m-tab-lock {
  font-size: 0.8em;
  color: var(--back-color);
}

@media screen and (max-width: 420px) {
  .m-tab-link {
    font-size: 26px;
    line-height: 33.8px;
  }
}
</style>
